import { observable, action, computed } from "mobx";
import {post} from "../services/ajax.service";

class RebatesStore {
  @observable total_spend = 0;
  @observable total_claims = 0;
  @observable total_rebate_guarantee = 0;
  @observable total_spend_rebate = 0;
  @observable net_performance = 0;
  @observable net_performance_percentage = 0;
  @observable average_brand_discount = 0;
  @observable average_generic_discount = 0;
  @observable performance_table = [];
  @observable rebatesGuarantee = {}
  @observable url ="/api/v1/performaneactions/rebates";

  @computed get net_performance_value() {
    return (
      (parseInt(this.total_spend) / 100) *
      parseInt(this.net_performance_percentage)
    );
  }
  @computed get total_rebates_amount() {
      let amount = 0;
      this.performance_table.map(p => {
          if(this.rebatesGuarantee[p.category]){
              amount = amount + this.rebatesGuarantee[p.category]*p.TOTAL_CLAIMS
          }
      })

      return amount;
  }

  @action returnRebatesGuarantee = (type) => {
    if(this.rebatesGuarantee[type]){
      return this.rebatesGuarantee[type];
    }
    else {
      return 0;
    }
  }
  @action getPerformance = async data => {
    try {
      let response = await post(
        `${this.url}/getPerformance`,
        data
      );

      this.net_performance_percentage = response.data[0].PERFORMANCE_CHANGE;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalSpend = async data => {
    try {
      let response = await post(
        `${this.url}/getTotalSpend`,
        data
      );

      this.total_spend = response.data[0].TOTAL_SPEND;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalClaims = async data => {
    try {
      let response = await post(
        `${this.url}/getTotalClaims`,
        data
      );

   
if(data.performance_review === "reconciliation"){
  this.total_claims = response.data[0].TOTAL_CLAIMS;
  this.total_rebate_guarantee = response.data[0].TOTAL_REBATE_GUARANTEE;
  this.total_spend_rebate = response.data[0].TOTAL_SPEND;
}
else{
      this.total_claims = response.data[0].TOTAL_CLAIMS;
}
    } catch (err) {
      console.log(err);
    }
  };

  @action getGenericDiscount = async data => {
    try {
      let response = await post(
        `${this.url}/getGenericDiscount`,
        data
      );

      this.average_generic_discount = response.data[0].AVERAGE_GENERIC_DISCOUNT;
    } catch (err) {
      console.log(err);
    }
  };

  @action getBrandedDiscount = async data => {
    try {
      let response = await post(
        `${this.url}/getBrandedDiscount`,
        data
      );

      this.average_brand_discount = response.data[0].AVERAGE_BRANDED_DISCOUNT;
    } catch (err) {
      console.log(err);
    }
  };

  @action getPerformanceTable = async data => {
    try {
      let response = await post(
        `${this.url}/getPerformanceTable`,
        data
      );

      this.performance_table = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getRebatesGuarantee = async data => {
    try {
      let response = await post(
        `${this.url}/getRebatesGuarantee?type=${data.market_check? "market_check":""}`,
        data
      );

      this.rebatesGuarantee = response.data[0] ? this.rebatesGuarantee = response.data[0] : {};
    } catch (err) {
      console.log(err);
    }
  };

  
}

export default RebatesStore;
